<template>
  <div class="slider_area clear-fix" dir="ltr">
    <Agile class="main" ref="main" :options="options1" :as-nav-for="asNavFor1">
      <div
        class="slide"
        v-for="(slide, index) in slideList"
        :key="index"
        :class="`slide--${index}`"
      >
        <img
          v-bind="mainImgProps"
          :src="slide"
          :alt="altText"
          @error="showDefaultImage"
        />
      </div>
    </Agile>
    <Agile
      class="thumbnails"
      ref="thumbnails"
      :options="options2"
      :as-nav-for="asNavFor2"
      v-if="showThumb"
    >
      <div
        class="slide slide--thumbniail"
        v-for="(slide, index) in slideList"
        :key="index"
        :class="`slide--${index}`"
        @click="$refs.main.goTo(index)"
      >
        <img
          v-bind="mainImgProps"
          :src="slide"
          :alt="altText"
          @error="showDefaultImage"
        />
      </div>
    </Agile>
  </div>
</template>

<script>

export default {
  name: 'Carousel',
  components: {
    Agile: () => import('@/components/atoms/agile/Agile'),
  },
  props: {
    slides: {
      type: Array,
      default: () => [],
    },
    showThumb: {
      type: Boolean,
      default: true,
    },
    numThumb: {
      type: Number,
      default: 3,
    },
    defaultImage: {
      type: String,
      default: '',
    },
    altText: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      asNavFor1: [],
      asNavFor2: [],
      options1: {
        dots: false,
        navButtons: false,
      },
      options2: {
        autoplay: true,
        dots: false,
        centerMode: true,
        navButtons: false,
        slidesToShow: this.numThumb,
      },
      mainImgProps: {
        fluidGrow: true,
        blank: true,
        blankColor: '#bbb',
      },
    };
  },
  computed: {
    slideList() {
      const tmpList = [
        '/assets/img/app/banner1.jpg',
        '/assets/img/app/banner1.jpg',
        '/assets/img/app/banner1.jpg',
        '/assets/img/app/banner1.jpg',
      ];
      return this.slides.length === 0 ? tmpList : this.slides;
    },
  },
  beforeMount() {
  },
  mounted() {
    setTimeout(() => {
      this.asNavFor1.push(this.$refs.thumbnails);
      this.asNavFor2.push(this.$refs.main);
    }, 2000);
  },
  methods: {
    showDefaultImage(ev) {
      ev.target.src = this.defaultImage;
    },
  },
};
</script>

<style scoped>
/* R5 B24: Premium gallery */
.slider_area {
  max-width: 720px;
  margin: 0 auto;
  padding: 12px;
  position: relative;
}
.main {
  margin-bottom: 12px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.06);
  position: relative;
}
.main::after {
  /* subtle bottom gradient overlay for premium feel */
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.18) 100%);
  pointer-events: none;
  z-index: 1;
}

.thumbnails {
  margin: 0 -4px;
  width: calc(100% + 8px);
}

.agile__nav-button {
  background: transparent;
  border: none;
  color: #ccc;
  cursor: pointer;
  font-size: 24px;
  transition-duration: 0.3s;
}
.thumbnails .agile__nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.thumbnails .agile__nav-button--prev {
  left: -45px;
}
.thumbnails .agile__nav-button--next {
  right: -45px;
}
.agile__nav-button:hover {
  color: #888;
}
.agile__dot {
  margin: 0 10px;
}
.agile__dot button {
  background-color: #eee;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: block;
  height: 10px;
  font-size: 0;
  line-height: 0;
  margin: 0;
  padding: 0;
  transition-duration: 0.3s;
  width: 10px;
}
.agile__dot--current button, .agile__dot:hover button {
  background-color: #888;
}

.slide {
  align-items: center;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  height: 450px;
  justify-content: center;
}
.slide--thumbniail {
  cursor: pointer;
  height: 78px;
  padding: 0 4px;
  transition: opacity 0.25s ease, transform 0.18s ease;
}
.slide--thumbniail img {
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
  transition: box-shadow 0.18s ease, transform 0.18s ease, filter 0.18s ease;
  filter: brightness(0.92);
}
.slide--thumbniail:hover img {
  filter: brightness(1.05);
  transform: scale(1.04);
  box-shadow: 0 4px 12px rgba(28, 126, 214, 0.2);
}
.slide img {
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
  -o-object-position: center;
     object-position: center;
  width: 100%;
  border-radius: 12px;
}
.main .slide img {
  border-radius: 16px;
}

/* Counter badge in bottom corner showing image position */
.slider_area::before {
  content: '';
}

@media (max-width: 479px) {
  .slider_area {
    padding: 8px;
  }
  .slide--thumbniail {
    height: 64px;
    padding: 0 3px;
  }
  .main {
    border-radius: 14px;
  }
}
</style>
